"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamIDUtils = exports.toStreamID = void 0;
/**
 * Create an instance of `StreamID` from a given string stream id or path.
 *
 * Supported formats:
 *  - full stream id format, e.g., '0x0000000000000000000000000000000000000000/foo/bar' or 'name.eth/foo/bar'
 *  - path-only format, e.g. , '/foo/bar'
 *  - key-exchange format, e.g., SYSTEM/keyexchange/0x0000000000000000000000000000000000000000
 *  - legacy format, e.g., '7wa7APtlTq6EC5iTCBy6dw'
 *
 *  If `streamIdOrPath` is not in path-only format, `domain` can be left undefined.
 */

function toStreamID(streamIdOrPath, domain) {
  if (streamIdOrPath.length === 0) {
    throw new Error('stream id may not be empty');
  }

  var firstSlashIdx = streamIdOrPath.indexOf('/');

  if (firstSlashIdx === -1) {
    // legacy format
    return streamIdOrPath;
  } else if (StreamIDUtils.isKeyExchangeStream(streamIdOrPath)) {
    // key-exchange format
    return streamIdOrPath;
  } else if (firstSlashIdx === 0) {
    // path-only format
    if (domain === undefined) {
      throw new Error("path-only format \"".concat(streamIdOrPath, "\" provided without domain"));
    }

    return domain.toLowerCase() + streamIdOrPath;
  } else {
    var _domain = streamIdOrPath.substring(0, firstSlashIdx).toLowerCase();

    var path = streamIdOrPath.substring(firstSlashIdx);
    return _domain + path;
  }
}

exports.toStreamID = toStreamID;

var StreamIDUtils = /*#__PURE__*/function () {
  function StreamIDUtils() {
    _classCallCheck(this, StreamIDUtils);
  }

  _createClass(StreamIDUtils, null, [{
    key: "formKeyExchangeStreamID",
    value: function formKeyExchangeStreamID(recipient) {
      return StreamIDUtils.KEY_EXCHANGE_STREAM_PREFIX + recipient.toLowerCase();
    }
  }, {
    key: "isPathOnlyFormat",
    value: function isPathOnlyFormat(streamIdOrPath) {
      return streamIdOrPath.startsWith('/');
    }
  }, {
    key: "isKeyExchangeStream",
    value: function isKeyExchangeStream(streamId) {
      return streamId.startsWith(StreamIDUtils.KEY_EXCHANGE_STREAM_PREFIX);
    }
  }, {
    key: "getDomain",
    value: function getDomain(streamId) {
      var domainAndPath = StreamIDUtils.getDomainAndPath(streamId);
      return domainAndPath === null || domainAndPath === void 0 ? void 0 : domainAndPath[0];
    }
  }, {
    key: "isENSName",
    value: function isENSName(domain) {
      return domain.indexOf('.') !== -1;
    }
  }, {
    key: "isENSAddress",
    value: function isENSAddress(address) {
      return address.indexOf('.') !== -1;
    }
  }, {
    key: "getPath",
    value: function getPath(streamId) {
      var domainAndPath = StreamIDUtils.getDomainAndPath(streamId);
      return domainAndPath === null || domainAndPath === void 0 ? void 0 : domainAndPath[1];
    }
  }, {
    key: "getDomainAndPath",
    value: function getDomainAndPath(streamId) {
      var firstSlashIdx = streamId.indexOf('/');

      if (firstSlashIdx !== -1 && !StreamIDUtils.isKeyExchangeStream(streamId)) {
        return [streamId.substring(0, firstSlashIdx), streamId.substring(firstSlashIdx)];
      } else {
        return undefined;
      }
    }
  }, {
    key: "getRecipient",
    value: function getRecipient(streamId) {
      if (StreamIDUtils.isKeyExchangeStream(streamId)) {
        return streamId.substring(StreamIDUtils.KEY_EXCHANGE_STREAM_PREFIX.length);
      }

      return undefined;
    }
  }]);

  return StreamIDUtils;
}();

exports.StreamIDUtils = StreamIDUtils;
StreamIDUtils.KEY_EXCHANGE_STREAM_PREFIX = 'SYSTEM/keyexchange/';